// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9503":"7cd3325da71e3874","9921":"208417ec6d0a8fc9"}[chunkId] + ".css";
};